export default __webpack_public_path__ + "static/media/fig-20-fault-proposed-filled.d40d26bd.png";